import { FormFieldValidation } from '@moia-dev/pace-web'
import {
  Controller,
  type ControllerProps,
  type FieldValues,
} from 'react-hook-form'
import { ComboboxField, type ComboboxFieldProps } from '../Basic'

export type FormComboboxFieldProps<
  FormFieldValues extends FieldValues,
  Value,
> = Omit<ComboboxFieldProps<Value>, 'value' | 'onChange'> &
  Pick<
    ControllerProps<FormFieldValues>,
    'control' | 'name' | 'rules' | 'disabled'
  > & {
    onChange?: (value: Value) => void
  }

export const FormComboboxField = <FormFieldValues extends FieldValues, Value>({
  name,
  control,
  rules,
  disabled,
  id,
  ...props
}: FormComboboxFieldProps<FormFieldValues, Value>) => {
  const maxLength =
    typeof rules?.maxLength === 'number' ? rules.maxLength : undefined

  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      render={({ field: { value, onChange, ...field }, fieldState }) => (
        <ComboboxField
          id={id}
          required={Boolean(rules?.required)}
          maxLength={maxLength}
          validation={
            fieldState.error?.message && (
              <FormFieldValidation type="error">
                {fieldState.error.message}
              </FormFieldValidation>
            )
          }
          error={Boolean(fieldState.error?.type)}
          disabled={disabled}
          {...props}
          {...field}
          value={value}
          onChange={newValue => {
            onChange(newValue)
            if (props.onChange) {
              props.onChange(newValue as Value)
            }
          }}
        />
      )}
    />
  )
}
